import {Component, EventEmitter, Inject, Injector, Input, OnInit, Optional, Output} from '@angular/core';
import {NzMessageService, NzModalService} from 'ng-zorro-antd';
import {CardAlternativesComponent} from './components/card-alternatives.component';
import * as _ from 'lodash';
import {DashboardService, DASHBOARDSERVICE} from './config';

@Component({
    selector: 'zj-single-dashboard',
    template: `<div nz-row [nzGutter]="16">
    <div nz-col [nzSpan]="20">
        <span style="font-size: 24px;font-weight: 500;">{{name}}</span>
        <span>{{description}}</span>
    </div>
    <div nz-col [nzSpan]="4" style="text-align: right;font-size: 20px;">
        <i class="anticon anticon-edit" style="padding: 4px 27px 0 0;" *ngIf="!setting" (click)="openSettings()"></i>
        <i class="anticon anticon-save" style="padding: 4px 27px 0 0;" *ngIf="setting" (click)="saveSetting()"></i>
        <!--<i class="anticon anticon-close-square-o" style="padding: 4px 10px 0 0;" *ngIf="setting" (click)="cancel()"></i>-->
    </div>
</div>
<div nz-row [nzGutter]="16">
    <div nz-col class="gutter-row" [nzSpan]="6" *ngFor="let card of cards; index as i;">
        <div class="card-item">
            <home-chart [id]="card.id" [dashboardService]="dashboardService"></home-chart>
        </div>
        <div class="overlay" *ngIf="setting">
            <span class="title">name</span>
            <i class="anticon anticon-delete" (click)="deleteCard(i)"></i>
            <i class="anticon anticon-edit" (click)="cardModal(card)" style="padding-right: 8px;"></i>
        </div>
    </div>
</div>
<div nz-row [nzGutter]="16">
    <div nz-col class="gutter-row" [nzSpan]="12" *ngFor="let tabset of tabs; index as r;">
        <nz-tabset>
            <nz-tab *ngIf="tabset.length === 0 && setting === true">
                <ng-template #nzTabHeading>
                    <i class="anticon anticon-plus" (click)="addTab(r)"></i>
                </ng-template>
                <div style="height: 99%;"></div>
            </nz-tab>
            <nz-tab *ngFor="let tab of tabset; index as i; last as isLast;trackBy: trackByFn;">
                <ng-template #nzTabHeading>
                    {{tab.name}}
                    <span *ngIf="setting">
                      <i class="anticon anticon-plus" *ngIf="isLast" (click)="addTab(r)"></i>
                      <i class="anticon anticon-cross" (click)="deleteTab(i,r)"></i>
                      <i class="anticon anticon-swap" *ngIf="!tab.pending" (click)="openPanel(i,r)"></i>
                      <i class="anticon anticon-check" *ngIf="tab.pending" (click)="swap(i,r)"></i>
                    </span>
                </ng-template>
                <div style="height: 99%;overflow: auto;">
                    <ng-template [ngIf]="!tab.pending">
                        <home-chart [id]="tab.id" [dashboardService]="dashboardService"></home-chart>
                    </ng-template>
                    <ng-template [ngIf]="tab.pending">
                        <tab-alt [alts]="alternatives" [index]="[i,r]" (tabSelect)="selectTab($event)"></tab-alt>
                    </ng-template>
                </div>
            </nz-tab>
        </nz-tabset>
    </div>
</div>

<div class="mask" *ngIf="openSetting">
    <nz-spin [nzSize]="'large'"></nz-spin>
</div>
`,
    styles: [`:host{height:100%;padding:0;position:relative;overflow:auto}:host /deep/ .ant-tabs-content.ant-tabs-content-animated{height:calc(100% - 52px)}:host /deep/ .ant-tabs-content.ant-tabs-content-animated .ant-tabs-tabpane{height:100%!important}.mask{position:fixed;top:0;right:0;left:0;bottom:0;opacity:.4;background:#0f0e0e;align-items:center;justify-content:center;display:flex;z-index:1233}div[nz-row]{margin-left:10px!important;margin-right:10px!important}div[nz-row] .gutter-row{height:98%}div[nz-row]:first-child{height:4%}div[nz-row]:nth-child(2){height:26%}div[nz-row]:last-child{padding-top:15px;height:70%}div[nz-row]:last-child nz-tabset{height:99.99%;background-color:rgba(255,255,255,.1);border-radius:7px;box-shadow:1px 1px 4px rgba(0,0,0,.15)}div[nz-row]:last-child nz-tabset nz-tab{height:100%}.card-item{height:99%;background-color:rgba(255,255,255,.1);border-radius:7px;box-shadow:1px 1px 4px rgba(0,0,0,.15)}.anticon{float:right;padding:0 3px;line-height:20px}.anticon:hover{color:#21e616;cursor:pointer}.anticon.anticon-check,.anticon.anticon-cross,.anticon.anticon-plus,.anticon.anticon-swap{width:21px!important;height:21px!important}.anticon.anticon-check:hover,.anticon.anticon-cross:hover,.anticon.anticon-plus:hover,.anticon.anticon-swap:hover{background-color:#43b3f0}.anticon.anticon-check{margin-left:18px}.anticon.anticon-swap{margin-left:10px}.overlay{display:block;position:absolute;bottom:0;left:8px;right:8px;height:20px;font-size:16px;color:#8fbc8f;-webkit-animation:1s infinite alternate flash;animation:1s infinite alternate flash}.overlay .title{float:left;font-size:14px;padding-left:10px;line-height:20px}@-webkit-keyframes flash{0%{background-color:rgba(103,229,48,.8);-webkit-transform:scale(1,1);transform:scale(1,1)}100%{background-color:rgba(224,229,34,.99);-webkit-transform:scale(1.001,1.001);transform:scale(1.001,1.001)}}@keyframes flash{0%{background-color:rgba(103,229,48,.8);-webkit-transform:scale(1,1);transform:scale(1,1)}100%{background-color:rgba(224,229,34,.99);-webkit-transform:scale(1.001,1.001);transform:scale(1.001,1.001)}}`]
})
export class DashboardComponent implements OnInit {

    data: any;   // dynamic created

    @Input() pageId;
    @Input() dashboardService;

    @Output() onSuccess = new EventEmitter();

    name;
    description;

    openSetting = false;
    setting = false;
    cards;
    tabs;
    alternatives;

    // å½åé©¾é©¶è±éç½®é¡¹
    currentSettings: any;

    pendingTabs = [];

    constructor(private modal: NzModalService,
                @Inject(DASHBOARDSERVICE) @Optional() dashboardService,
                private injector: Injector,
                private _message: NzMessageService) {
        if (dashboardService) {
            this.dashboardService = dashboardService;
        }
    }

    cardModal(card) {
        this.modal.open({
            content: CardAlternativesComponent,
            footer: false,
            componentParams: {
                card: card,
                cards: this.cards,
                alts: this.alternatives
            }
        }).subscribe(value => {
            if (value.id) {
                this.cards[this.cards.indexOf(card)] = value;
            }
        }, () => {

        });
    }

    deleteCard(i) {
        this.cards[i] = {};
    }

    openPanel(i, r) {
        this.tabs[r][i] = {
            name: 'è¯·éæ©...',
            pending: true
        };
    }

    swap(i, r) {
        let index = -1;
        this.pendingTabs.forEach((val, idx) => {
            if (val.index[0] === i && val.index[1] === r) {
                this.tabs[r][i] = val.tab;
                index = idx;
            }
        });
        if (index !== -1) {
            this.pendingTabs.splice(index, 1);
        }
    }

    deleteTab(i, r) {
        let index = -1;
        this.pendingTabs.forEach((val, idx) => {
            if (val.index[0] === i && val.index[1] === r) {
                index = idx;
            }
        });
        if (index !== -1) {
            this.pendingTabs.splice(index, 1);
        }

        this.tabs[r].splice(i, 1);
    }

    addTab(r) {
        this.tabs[r].push(
            {
                name: 'è¯·éæ©...',
                pending: true
            }
        );
        // éè¦è°ç¨nz-tabsetçç»ä»¶æ¹æ³æ¥æ¿æ´»æ°å¢çéé¡¹
    }

    selectTab(evt) {
        _.forEachRight(this.pendingTabs, (val, idx) => {
            if (val.index[0] === evt.index[0] && val.index[1] === evt.index[1]) {
                this.pendingTabs.splice(idx, 1);
            }
        });
        this.pendingTabs.push({
            tab: evt.tab,
            index: evt.index
        });
    }

    openSettings() {
        this.openSetting = true;
        this.currentSettings = {
            cards: [].concat(this.cards),
            tabs: [Array.prototype.concat(this.tabs[0]), Array.prototype.concat(this.tabs[1])]
        };
        setTimeout(() => {
            this.setting = true;
            this.openSetting = false;
        }, 500);
    }

    /**
     * 1.è¿æ»¤pendingä¸ºtrueçtab
     * 2.ä¿å­è®¾ç½®å°æå¡ç«¯
     */
    saveSetting() {
        this.openSetting = true;

        for (let l = this.tabs[0].length - 1; l >= 0; l--) {
            if (this.tabs[0][l].pending === true) {
                this.tabs[0].splice(l, 1);
            }
        }
        for (let l = this.tabs[1].length - 1; l >= 0; l--) {
            if (this.tabs[1][l].pending === true) {
                this.tabs[1].splice(l, 1);
            }
        }

        const homeDef = {
            cards: [],
            tabs: [[], []]
        };

        this.cards.forEach(val => {
            homeDef.cards.push({id: val.id});
        });

        this.tabs.forEach((tabSet, index) => {
            tabSet.forEach(val => {
                homeDef.tabs[index].push({id: val.id, name: val.name});
            });
        });

        if (this.dashboardService.updatePageDefById) {
            this.dashboardService.updatePageDefById({
                pageId: this.pageId, homeDef: homeDef
            }).subscribe(data => {
                this.setting = false;
                this.openSetting = false;
                this._message.success('é©¾é©¶è±éç½®æåï¼');
                this.onSuccess.emit('é©¾é©¶è±éç½®æå');
            }, err => {
                this.openSetting = false;
                this._message.error(err.body.retMsg);
            });
        } else {
            this._message.error('æ¨æä¼ éé©¾é©¶è±éç½®æå¡æè¯¯ï¼\n è¯·ç¡®å®å¶ä¿å­çæå¡åä¸º"updatePageDefById"');
        }
    }

    ngOnInit(): void {

        this.pageId = this.pageId || this.data.pageId;

        if (!this.pageId) {
            this._message.error('è·åä¸»é¡µidå¤±è´¥ï¼');
            return;
        }

        if (this.dashboardService.getPageDefById) {
            // è·åå½åä¸»é¡µéç½®
            this.dashboardService.getPageDefById(this.pageId)
                .subscribe((data: any) => {
                    this.cards = data.homeDef.cards;
                    this.tabs = data.homeDef.tabs;
                    this.name = data.themeName;
                    this.description = data.themeDesc;
                }, err => {
                    this._message.error(err.body.retMsg);
                });
        } else {
            this._message.error('æ¨æä¼ éé©¾é©¶è±éç½®æå¡æè¯¯ï¼\n è¯·ç¡®å®å¶è·åé¡µé¢éç½®ä¿¡æ¯çæå¡åä¸º"getPageDefById"');
        }

        if (this.dashboardService.getChartsDef) {
            // è·åå¯éæ©åå®¹
            this.dashboardService.getChartsDef()
                .subscribe((data) => {
                    this.alternatives = data.filter((value) => {
                        return value.type === '0';
                    });
                }, err => {
                    this._message.error(err.body.retMsg);
                });
        } else {
            this._message.error('æ¨æä¼ éé©¾é©¶è±éç½®æå¡æè¯¯ï¼\n è¯·ç¡®å®å¶è·åææå¾è¡¨éç½®ä¿¡æ¯çæå¡åä¸º"getChartsDef"');
        }
    }

    cancel() {
        this.cards = this.currentSettings.cards;
        this.tabs = this.currentSettings.tabs;
        this.setting = false;
        this.openSetting = false;
    }

    trackByFn(index) {
        return index;
    }


}

